/**
 * CAL_TIMINGS — calendar animation timing constants (Plan 03-06).
 *
 * Per UI-SPEC §Animation Timing Constants (Phase 3 calendar surfaces).
 * Consumed by EventEditSheet (Plan 03-08), push-highlight (Plan 03-09),
 * WeekView/DayView crossfade (Plan 03-07).
 *
 * `reducedMotion` branch collapses all durations to 0ms per the
 * `prefers-reduced-motion: reduce` accessibility requirement (Phase 1 + 2
 * carry-forward + Phase 3 D-06 explicit statement).
 */
export const CAL_TIMINGS = {
  /** View crossfade (month→week→day tab switch). */
  viewCrossfade: { duration: 180, easing: 'ease-out' },

  /** Bottom-sheet enter animation (EventEditSheet). */
  sheetEnter: 240,

  /** Bottom-sheet exit animation (EventEditSheet). */
  sheetExit: 200,

  /** Event push-deep-link highlight pulse. */
  pushHighlight: { duration: 1200, iterations: 1, keyframes: 'outline-pulse' },

  /** How often the "now" line in DayView/WeekView advances (ms). */
  nowLineTick: 60_000,

  /** How often the Today view and EventsTile refetch data (ms). */
  todayRefetchInterval: 30 * 60 * 1000,

  /** prefers-reduced-motion: reduce branch — all durations collapse. */
  reducedMotion: {
    durations: 0,
    pushHighlight: { duration: 0, staticOutlineDuration: 2000 },
  },
} as const;
